module.exports = __webpack_public_path__ + "img/fruehstueckextra.83ac3597.png";